import { Component } from 'react';
import { AjaxWrapper, HttpMethod } from '../../generic/ajaxWrapper';

interface Props {
  children: any,
}
export class ScriptLoader extends Component<Props, any> {
  constructor(props) {
    super(props)
  }

  public componentDidMount() {
    const currentDomain = window.location.hostname;
    const url: string = AjaxWrapper.getServerUrl() + `/public/partner-config/${currentDomain}`
    AjaxWrapper.ajax(url, HttpMethod.GET, null).then((configs: {scripts: [{ id: string; src: string; }]}) => {
      const scripts = configs.scripts || []
      scripts.forEach(({ id, src }) => {
        if (!document.getElementById(id)) {
          const script = document.createElement("script");
          script.id = id;
          script.src = src;
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);
        }
      });
    })
  }
  public render() {
    return this.props.children;
  }
}
